import { Component } from 'react';
import { func } from 'prop-types';

import { debounce } from '~/utils';

export class Media extends Component {
  static greaterThan = (screenWidth, breakpointWidth) => screenWidth >= breakpointWidth;

  static lessThan = (screenWidth, breakpointWidth) => screenWidth < breakpointWidth;

  static BREAKPOINTS = {
    XXS: 375,
    XS: 600,
    SM: 768,
    MD: 1024,
    LG: 1280,
  };

  state = {
    screenWidth: window.innerWidth,
  };

  handleWindowResize = debounce(() => {
    this.setState({ screenWidth: window.innerWidth });
  }, 50);

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  render() {
    const { children } = this.props;

    return children(this.state);
  }
}

Media.propTypes = {
  children: func.isRequired,
};
